import { render, staticRenderFns } from "./RegistroArgomenti.vue?vue&type=template&id=74c0471a&scoped=true&"
import script from "./RegistroArgomenti.vue?vue&type=script&lang=js&"
export * from "./RegistroArgomenti.vue?vue&type=script&lang=js&"
import style0 from "./RegistroArgomenti.vue?vue&type=style&index=0&id=74c0471a&prod&scoped=true&lang=css&"
import style1 from "./RegistroArgomenti.vue?vue&type=style&index=1&id=74c0471a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c0471a",
  null
  
)

export default component.exports